/* eslint-disable */
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  NavbarAdmin,
  NavbarUser as Navbar,
  NavbarSuperAdmin,
} from '../components/Navbar';
import NavbarEDonation from '../components/Navbar/NavbarEDonation';
import Sidebar from '../components/Sidebar/Sidebar';
import SidebarAdmin from '../components/Sidebar/SidebarAdmin';
import SidebarSuperAdmin from '../components/Sidebar/SidebarSuperAdmin';
import SidebarAdminNewDesign from '../components/Sidebar/SidebarAdminNewDesgin';
import SidebarSuperAdminNewDesign from '../components/Sidebar/SidebarSuperAdminNewDesign';
import SidebarEEntry from '../components/Sidebar/SidebarEEntry';
import SidebarAdminEEntry from '../components/Sidebar/SidebarAdminEEntry';
import SidebarSuperAdminEEntry from '../components/Sidebar/SidebarSuperAdminEEntry';
import SidebarEEntryNewDesign from '../components/Sidebar/SidebarEEntryNewDesign';
import SidebarAdminEEntryNewDesign from '../components/Sidebar/SidebarAdminEEntryNewDesign';
import SidebarSuperAdminEEntryNewDesign from '../components/Sidebar/SidebarSuperAdminEEntryNewDesign';
import SidebarEDonation from '../components/Sidebar/SidebarEDonation';
import ButtomBar from '../components/Sidebar/BottomBar';
import { ROLES } from '../utils/constants';
import { getSystem } from '../utils/functions/accessRight';
import { getStorage } from '../utils/functions/localstorage';

function DashboardLayout({ checkAccessRights, checkAccessRightsEEntry }) {
  const EDonation = getStorage('eDoanation');
  const System = getSystem();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [open, setOpen] = useState(true);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };
  const renderSidebarFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE) && EDonation === 'E-Donation') {
      return (
        <SidebarEDonation
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarEDonation>
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE) && System === 'ecashier') {
      return (
        <SidebarAdminNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarAdminNewDesign>
      );
    }
    if (checkAccessRights(ROLES.ADMINUSER_ROLE) && System === 'ecashier') {
      return (
        <SidebarAdminNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarAdminNewDesign>
      );
    }
    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE) && System === 'ecashier') {
      return (
        <SidebarSuperAdminNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarSuperAdminNewDesign>
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE) && System === 'ecashier') {
      /* ADMIN LAYOUT */
      return (
        <SidebarAdmin
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
        >
          <Outlet />
        </SidebarAdmin>
      );
    }
    if (checkAccessRights(ROLES.ADMINUSER_ROLE) && System === 'ecashier') {
      /* SUPERADMIN LAYOUT */
      return (
        <SidebarSuperAdminNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
        >
          <Outlet />
        </SidebarSuperAdminNewDesign>
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE) && System === 'eentry') {
      return (
        <SidebarEEntryNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarEEntryNewDesign>
      );
    }
    if (checkAccessRights(ROLES.ADMINUSER_ROLE) && System === 'eentry') {
      return (
        <SidebarAdminEEntryNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarAdminEEntryNewDesign>
      );
    }
    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE) && System === 'eentry') {
      return (
        <SidebarSuperAdminEEntryNewDesign
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          open={open}
          setOpen={setOpen}
        >
          <Outlet />
          <ButtomBar />
        </SidebarSuperAdminEEntryNewDesign>
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE) && System === 'eentry') {
      /* ADMIN LAYOUT */
      return (
        <SidebarAdmin
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
        >
          <Outlet />
        </SidebarAdmin>
      );
    }
    if (checkAccessRights(ROLES.ADMINUSER_ROLE) && System === 'eentry') {
      /* SUPERADMIN LAYOUT */
      return (
        <SidebarSuperAdmin
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
        >
          <Outlet />
        </SidebarSuperAdmin>
      );
    }
    return <></>;
  };
  const renderNavbarFromAccessibleRole = () => {
    if (checkAccessRights(ROLES.USER_ROLE) && EDonation === 'E-Donation') {
      return (
        // <div className="container">
        <NavbarEDonation
          openMobile={isMobileNavOpen}
          onMobileNavOpen={handleOnMobileNavOpen}
          onMobileNavClose={handleOnMobileNavClose}
        />
        // </div>
      );
    }
    if (checkAccessRights(ROLES.USER_ROLE)) {
      return (
        // <div className="container">
        <Navbar
          openMobile={isMobileNavOpen}
          onMobileNavOpen={handleOnMobileNavOpen}
          onMobileNavClose={handleOnMobileNavClose}
        />
        // </div>
      );
    }
    if (checkAccessRights(ROLES.ADMINUSER_ROLE)) {
      /* ADMIN LAYOUT */
      return (
        <NavbarAdmin
          openMobile={isMobileNavOpen}
          onMobileNavOpen={handleOnMobileNavOpen}
          onMobileNavClose={handleOnMobileNavClose}
        />
      );
    }
    if (checkAccessRights(ROLES.SUPER_ADMIN_ROLE)) {
      /* SUPERADMIN LAYOUT */
      return (
        <NavbarSuperAdmin
          openMobile={isMobileNavOpen}
          onMobileNavOpen={handleOnMobileNavOpen}
          onMobileNavClose={handleOnMobileNavClose}
        />
      );
    }
    return <></>;
  };
  return (
    <div>
      {renderNavbarFromAccessibleRole()}
      {renderSidebarFromAccessibleRole()}
    </div>
  );
}

export default DashboardLayout;
